import React, { useEffect } from 'react';
import SimpleActionItemTable from 'Components/UI/SimpleActionItemTable';
import { addQuery, QueryVal } from 'Helpers/Query';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import relationships from 'Consts/Relationships';
import PropTypes from 'prop-types';

const HouseholdSimpleActionItem = ({ classes }) => {
  const { householdResource } = useSimpleHousehold();

  useEffect(() => {
    addQuery({ link: householdResource?.relationship(relationships.simpleActionItems).link('related').url() });
  }, [householdResource?.id()]);

  if (!householdResource?.relationship(relationships.simpleActionItems).link('related').url()) {
    return null;
  }
  const queryLink = QueryVal('link');
  return (
    <div className={classes.root}>
      {queryLink && <SimpleActionItemTable /> }
    </div>
  );
};

HouseholdSimpleActionItem.propTypes = {
  classes: PropTypes.object,
};

HouseholdSimpleActionItem.defaultProps = {
  classes: {
    root: '',
  },
};


export default HouseholdSimpleActionItem;
